import _extends from 'babel-runtime/helpers/extends';

export default {
  name: 'Multi-LineText',

  componentName: 'MultiLineText',

  props: {
    config: {
      type: Object,
      required: true
    },
    formValue: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {};
  },


  computed: {
    innerConfig: function innerConfig() {
      var params = _extends({}, this.config.params);
      return _extends({}, this.config, {
        params: params
      });
    }
  },

  methods: {},

  mounted: function mounted() {}
};